export default __webpack_public_path__ + "static/media/flag-sint-maarten.2afd4657.svg";